import Client from './Client';
import Quote from '../models/Quote';

export type ZoneClientCatalogItem = {
    id: number;
    name: string;
    shortDescription?: string | null;
    itemgroupId?: number | null;
    itemgroupName?: string | null;
    renewPeriod?: number | null;
    paymentDelay?: number | null;
};

class ClientArea extends Client {
    syncClients() {
        return this.GET('/plugins/client_area/clients/sync')
            .then(async (response) => {
                if (response.status === 406)
                    throw new Error('plugin_disabled');
                if (!response.ok)
                    throw new Error(`http_${response.status}`);

                const result = await response.json();
                if (result !== true)
                    throw new Error('sync_failed');

                return result;
            });
    }

    getCatalog() {
        return this.GET('/plugins/client_area/catalog')
            .then(async (response) => {
                const json = await response.json();
                if (!response.ok)
                    throw new Error(json.err || `http_${response.status}`);
                return {
                    items: (json.items || []) as ZoneClientCatalogItem[],
                    itemgroups: (json.itemgroups || []) as { id: number; name: string }[],
                };
            });
    }

    syncQuoteSales(quoteId: string) {
        return this.POST(`/plugins/client_area/quotes/${quoteId}/sales`, {})
            .then(async (response) => {
                const json = await response.json();
                if (!response.ok)
                    throw new Error(json.err || `http_${response.status}`);
                return {
                    ...json,
                    quote: json.quote ? new Quote(json.quote) : null,
                };
            });
    }
}

const ClientAreaApi = new ClientArea();

export default ClientAreaApi;
